import React from 'react';
import { Link } from 'react-router-dom';

const UserFooter = () => {
  return (
    <footer className="bg-[#1a1a1a] text-gray-300 mb-14">

      {/* Trust Strip */}
      <div className="border-b border-gray-800 px-4 py-5">
        <div className="grid grid-cols-2 gap-4 text-center">
          {[
            { icon: '🚚', title: 'Free Delivery', desc: 'On all orders' },
            { icon: '🔄', title: 'Easy Returns', desc: '24-hour hassle-free' },
            { icon: '🔒', title: 'Secure Pay', desc: 'SSL encrypted' },
            { icon: '✅', title: '100% Genuine', desc: 'Verified sellers' },
          ].map((item, i) => (
            <div key={i} className="flex flex-col items-center gap-1">
              <span className="text-lg">{item.icon}</span>
              <span className="text-white text-[11px] font-semibold">{item.title}</span>
              <span className="text-gray-500 text-[9px]">{item.desc}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Brand Section */}
      <div className="px-4 pt-8 pb-6 border-b border-gray-800">
        <div className="flex items-center gap-2.5 mb-3">
          <img src="/images/zammer-official-logo.png" alt="ZAMMER" className="w-8 h-8 rounded-lg object-contain" />
          <span className="text-lg font-black text-white tracking-wider uppercase">ZAMMER</span>
        </div>
        <p className="text-[13px] leading-relaxed text-gray-400 mb-4">
          India's local-first fashion marketplace. Shop from nearby sellers, discover curated collections, and get delivered fast.
        </p>

        {/* Contact */}
        <div className="space-y-1.5 mb-4">
          <a href="mailto:DARSHAN@ZAMMERNOW.COM" className="flex items-center gap-2 text-gray-400 hover:text-white text-[12px] transition-colors">
            <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" /></svg>
            DARSHAN@ZAMMERNOW.COM
          </a>
          <a href="https://zammernow.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-white text-[12px] transition-colors">
            <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" /></svg>
            www.zammernow.com
          </a>
        </div>

        {/* App Store Badges */}
        <div className="flex items-center gap-2.5">
          <a href="#" className="flex items-center gap-2 border border-gray-700 rounded-lg px-3 py-2 hover:border-gray-500 transition-colors">
            <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="currentColor"><path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-1.707l2.108 1.22a1 1 0 010 1.56l-2.108 1.22-2.537-2.5 2.537-2.5zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/></svg>
            <div className="text-left">
              <div className="text-[7px] text-gray-500 uppercase leading-none">Get it on</div>
              <div className="text-[10px] font-semibold text-white leading-tight">Google Play</div>
            </div>
          </a>
          <a href="#" className="flex items-center gap-2 border border-gray-700 rounded-lg px-3 py-2 hover:border-gray-500 transition-colors">
            <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
            <div className="text-left">
              <div className="text-[7px] text-gray-500 uppercase leading-none">Download on the</div>
              <div className="text-[10px] font-semibold text-white leading-tight">App Store</div>
            </div>
          </a>
        </div>
      </div>

      {/* Link Sections — 2x2 grid */}
      <div className="px-4 py-6 border-b border-gray-800">
        <div className="grid grid-cols-2 gap-x-6 gap-y-6">

          {/* Shop */}
          <div>
            <h4 className="text-[11px] font-bold text-white uppercase tracking-wider mb-3">Shop</h4>
            <ul className="space-y-2">
              {[
                { to: '/user/browse/Men%20Fashion', label: 'Men' },
                { to: '/user/browse/Women%20Fashion', label: 'Women' },
                { to: '/user/browse/Kids%20Fashion', label: 'Kids' },
                { to: '/user/trending', label: 'Trending' },
                { to: '/user/limited-edition', label: 'Limited Edition' },
                { to: '/user/products', label: 'All Products' },
              ].map((item, i) => (
                <li key={i}>
                  <Link to={item.to} className="text-gray-400 hover:text-white text-[12px] transition-colors">{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Help */}
          <div>
            <h4 className="text-[11px] font-bold text-white uppercase tracking-wider mb-3">Help</h4>
            <ul className="space-y-2">
              {[
                { to: '/contact', label: 'Contact Us' },
                { to: '/help', label: 'FAQs' },
                { to: '/user/orders', label: 'Track Order' },
                { to: '/policy/shipping', label: 'Shipping Info' },
                { to: '/policy/refund', label: 'Returns & Refunds' },
              ].map((item, i) => (
                <li key={i}>
                  <Link to={item.to} className="text-gray-400 hover:text-white text-[12px] transition-colors">{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-[11px] font-bold text-white uppercase tracking-wider mb-3">Company</h4>
            <ul className="space-y-2">
              {[
                { to: '/about', label: 'About ZAMMER' },
                { to: '/about', label: 'Our Story' },
                { to: '/contact', label: 'Careers' },
                { to: '/seller/login', label: 'Sell on ZAMMER' },
                { to: '/about', label: 'Press & Media' },
              ].map((item, i) => (
                <li key={i}>
                  <Link to={item.to} className="text-gray-400 hover:text-white text-[12px] transition-colors">{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h4 className="text-[11px] font-bold text-white uppercase tracking-wider mb-3">Policies</h4>
            <ul className="space-y-2">
              {[
                { to: '/policy/terms', label: 'Terms & Conditions' },
                { to: '/policy/privacy', label: 'Privacy Policy' },
                { to: '/policy/refund', label: 'Refund Policy' },
                { to: '/policy/shipping', label: 'Shipping Policy' },
              ].map((item, i) => (
                <li key={i}>
                  <Link to={item.to} className="text-gray-400 hover:text-white text-[12px] transition-colors">{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Newsletter */}
      <div className="px-4 py-6 border-b border-gray-800">
        <p className="text-[13px] font-semibold text-white mb-1">Stay in the loop</p>
        <p className="text-gray-500 text-[11px] mb-3">Subscribe for exclusive drops, offers & style tips.</p>
        <div className="flex">
          <input
            type="email"
            placeholder="Enter your email"
            className="flex-1 bg-transparent border border-gray-700 rounded-l-lg px-3 py-2.5 text-[13px] text-white placeholder-gray-500 focus:outline-none focus:border-white transition-colors"
          />
          <button className="bg-white text-[#1a1a1a] px-4 py-2.5 rounded-r-lg text-[11px] font-bold uppercase tracking-wider hover:bg-gray-200 transition-colors whitespace-nowrap">
            Subscribe
          </button>
        </div>
      </div>

      {/* Social Links */}
      <div className="px-4 py-4 flex items-center justify-center gap-4 border-b border-gray-800">
        {[
          { label: 'Instagram', path: 'M7.75 2h8.5A5.75 5.75 0 0122 7.75v8.5A5.75 5.75 0 0116.25 22h-8.5A5.75 5.75 0 012 16.25v-8.5A5.75 5.75 0 017.75 2zm0 1.5A4.25 4.25 0 003.5 7.75v8.5A4.25 4.25 0 007.75 20.5h8.5a4.25 4.25 0 004.25-4.25v-8.5A4.25 4.25 0 0016.25 3.5h-8.5zM12 7a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm5.25-2a.75.75 0 110 1.5.75.75 0 010-1.5z' },
          { label: 'Facebook', path: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
          { label: 'Twitter', path: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z' },
          { label: 'YouTube', path: 'M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z' },
        ].map((social, i) => (
          <a key={i} href="#" aria-label={social.label} className="w-9 h-9 border border-gray-700 rounded-full flex items-center justify-center text-gray-400 hover:text-white hover:border-gray-500 transition-colors">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d={social.path} /></svg>
          </a>
        ))}
      </div>

      {/* Bottom Bar */}
      <div className="px-4 py-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <span className="text-gray-600 text-[10px]">We accept</span>
            <div className="flex items-center gap-1.5 text-gray-500 text-[10px] font-medium">
              <span className="border border-gray-700 rounded px-1.5 py-0.5">VISA</span>
              <span className="border border-gray-700 rounded px-1.5 py-0.5">UPI</span>
              <span className="border border-gray-700 rounded px-1.5 py-0.5">RuPay</span>
              <span className="border border-gray-700 rounded px-1.5 py-0.5">COD</span>
            </div>
          </div>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="w-7 h-7 border border-gray-700 rounded-full flex items-center justify-center text-gray-400 hover:text-white hover:border-gray-500 transition-colors"
            aria-label="Back to top"
          >
            <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" /></svg>
          </button>
        </div>
        <p className="text-gray-500 text-[10px] tracking-wide text-center">
          &copy; {new Date().getFullYear()} ZAMMER RETAIL PRIVATE LIMITED. ALL RIGHTS RESERVED.
        </p>
      </div>
    </footer>
  );
};

export default UserFooter;
